export default function FourthSection() {
  const services = [
    { img: "./special1.png", title: "Elementbauweise", desc: "Wir konstruieren und verwalten Gebäude und Infrastrukturen." },
    { img: "./special2.png", title: "Kernbohrungen", desc: "Wir konstruieren und verwalten Gebäude und Infrastrukturen." },
    { img: "./special3.png", title: "Abbrucharbeiten", desc: "Wir konstruieren und verwalten Gebäude und Infrastrukturen." },
    { img: "./Rectangle9.png", title: "Mauern", desc: "Wir konstruieren und verwalten Gebäude und Infrastrukturen." },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-6 md:px-10 max-w-7xl mx-auto pb-20">
      {services.map((service, i) => (
        <div
          key={i}
          className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 group"
        >
          <div className="overflow-hidden">
            <img
              src={service.img}
              alt={service.title}
              className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="p-5 text-center">
            <h3 className="text-darkBlue font-bold text-lg mb-2">{service.title}</h3>
            <p className="text-gray-500 text-sm">{service.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
